import {Typography} from '@yandex-delivery/ui'
import clsx from 'clsx'
import React, {type PropsWithChildren} from 'react'

import styleClasses from './classes.module.css'

type Props = PropsWithChildren<{
  title?: string
  className?: string
}>

export function Paper({children, title, className}: Props) {
  return (
    <div className={clsx(styleClasses.paper, className)}>
      {title && (
        <Typography className={styleClasses.title} density="tight" level="title4" weight="medium">
          {title}
        </Typography>
      )}
      {children}
    </div>
  )
}
